/**
 * Application Configuration
 * Centralized environment variable access
 */

export const config = {
  // Feature flags
  useBackend: import.meta.env.VITE_USE_BACKEND === 'true',

  // Environment
  environment: import.meta.env.MODE as 'development' | 'production' | 'test',
  isDevelopment: import.meta.env.MODE === 'development',
  isProduction: import.meta.env.MODE === 'production',

  // Supabase (for Phase 2+)
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL || '',
    anonKey: import.meta.env.VITE_SUPABASE_PUB_KEY || '',
  },

  // PostHog Analytics
  posthog: {
    apiKey: import.meta.env.VITE_POSTHOG_KEY || '',
    apiHost: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
  },
} as const

// Type-safe config access
export type Config = typeof config
